import moment from 'moment';
import _ from 'underscore';
import parseError from '../../../utils/parseError';
import { Toast } from '../../../../../../Components/Notification';


export const logStart = async ({userId, resource, day, logJobStart}) => {
  const operation = 3; // 3 = delete
  try {
    await logJobStart(userId, operation);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      console.log(error);
      let notification = {
        type: 'error',
        message: "Logging Job Start Error",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
      Toast(notification);
    }
  }
}

export const logFinish = async ({resource, logControlId, jobId, day, logJobFinish}) => {
    try {
      await logJobFinish(logControlId, jobId);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        console.log(error);
        let notification = {
          type: 'error',
          message: "Logging Job Finish Error",
          description: `For [${resource.name} on ${day}]: ${parseError(error)}`
        };
        Toast(notification);
      }
    }
}

export const removeJobElement = async ({resource, logControlId, userId, jobElementId, removeJobElement, day, updateState, refreshPage}) => {
  let notification = {type: 'success', message: 'Assignment Deleted', description: `For ${resource.name} on ${day}`};
  let parameters = {
    userId,
    jobElementId,
    logControlId
  };
  try {
    await removeJobElement(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeJobElement',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Assignment Failed",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

/**
 * delete empty job
 * this only gets fired when already deleting an assignment (job Element) and also decide to delete
 * job that is now empty as a result of its final assignment being deleted (empty job)
 */
export const removeJob = async ({resource, logControlId, userId, jobId, removeJob, day, updateState, refreshPage}) => {
  let notification = {type: 'success', message: 'Request Deleted', description: `For ${resource.name} on ${day}`};
  let parameters = {
    userId,
    jobId,
    logControlId
  };
  try {
    await removeJob(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'removeJob',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Deleting Request Failed",
        description: `For [${resource.name} on ${day}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  updateState({
    deleteEmptyJobLoading: false
  });
  refreshPage();
  // ok to refresh now, last step in process and need to refresh to disappear deleted assignment
}



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/assignment/deleteAssignment.js